"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var IncomeTaxBand = (function () {
    function IncomeTaxBand() {
        this._startOfBand = null;
        this._taxRateInBand = 0;
        this._taxToStartOfBand = 0;
    }
    IncomeTaxBand.prototype.index = function (yearCount) {
        this._startOfBand.index(yearCount);
    };
    IncomeTaxBand.prototype.setStartBand = function (startBand, indexationBasis) {
        this._startOfBand = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._startOfBand.initialise(startBand, indexationBasis);
    };
    IncomeTaxBand.prototype.setRateInBand = function (rate) {
        this._taxRateInBand = rate;
    };
    IncomeTaxBand.prototype.setTaxToStartOfBand = function (taxToStartOfBand) {
        this._taxToStartOfBand = taxToStartOfBand;
    };
    Object.defineProperty(IncomeTaxBand.prototype, "startOfTaxBand", {
        get: function () {
            return this._startOfBand.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IncomeTaxBand.prototype, "taxRateInBand", {
        get: function () {
            return this._taxRateInBand;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IncomeTaxBand.prototype, "taxToStartOfBand", {
        get: function () {
            return this._taxToStartOfBand;
        },
        enumerable: true,
        configurable: true
    });
    return IncomeTaxBand;
}());
exports.IncomeTaxBand = IncomeTaxBand;
//# sourceMappingURL=IncomeTaxBand.js.map